import PackageService from '../../services/PackageService'
import AxiosErrorHandler from '../../helpers/AxiosErrorHandler'
import router from '../../router'
import ProjectsService from '../../services/ProjectsService'
export const namespaced = true

const initialState = {
  packages: [],
  selectedPackage: null
}

export const state = {
  packages: [],
  selectedPackage: null
}

export const mutations = {
  SET_PACKAGES(state, recs) {
    state.packages = recs
  },
  SET_SELECTED_PACKAGE(state, rec) {
    state.selectedPackage = rec
  },
  RESET_STORE(state) {
    Object.assign(state, initialState)
  }
}

export const actions = {
  fetchPackages: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return ProjectsService.getProjectPackages(
      context.rootGetters['ProjectStore/getSelectedProjectId']
    ).then(
      r => {
        context.commit('SET_PACKAGES', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_PACKAGES', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  setSelectedPackage: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return PackageService.getProjectPackagesById(value).then(
      r => {
        context.commit('SET_SELECTED_PACKAGE', r.data)
        context.dispatch(
          'BreadcrumbsStore/add',
          {
            text: 'PACKAGE',
            name: r.data.name
          },
          { root: true }
        )
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_SELECTED_PACKAGE', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  addPackage: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })

    await PackageService.createProjectPackage(value)
    context.dispatch('fetchPackages')
  },
  updatePackage: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return PackageService.updateProjectPackage(value).then(
      res => {
        context.commit('SET_SELECTED_PACKAGE', res.data)
        context.dispatch(
          'BreadcrumbsStore/update',
          {
            text: 'PACKAGE',
            name: res.data.name
          },
          { root: true }
        )

        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        context.dispatch('fetchPackages')
      },
      e => {
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  deletePackage: async function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })

    try {
      await PackageService.deleteProjectPackage(value)
    } catch (error) {
      context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      AxiosErrorHandler.handler(error, context, router)
      throw error
    }
  },
  resetStore: async function(context) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    context.commit('RESET_STORE')
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
  }
}

export const getters = {
  getSelectedPackageId: state => {
    return state.selectedPackage ? state.selectedPackage.id : 0
  }
}
